export default "__VITE_ASSET__0408b6b5__"